import './UserMenu.scss';

import React from 'react';

import A from 'components/A';
import ActionMenu from 'components/ActionMenu';
import Icon from 'components/Icon';
import Thumbnail from 'components/Thumbnail';
import UserDetails from 'components/UserDetails';

export default class UserMenu extends React.Component {
    _handleClick(event) {
        let target = event.target;

        while(target.getAttribute('class') == null || target.getAttribute('class') !== 'user-menu') {
            target = target.parentNode;
        }

        target.querySelector('.action-menu').classList.add('active');
    }

    render() {
        let { user } = this.props;

        return (
            <div className="user-menu">
                <div className="user-menu__trigger"
                     onClick={this._handleClick.bind(this)}>
                    <Thumbnail defaultAvatar="users"
                               thumbnailID={user.thumbnail ? user.thumbnail.id : null}
                               alt={`${user.lastName}, ${user.firstName}`} />
                    <div className="user-menu__email">
                        {user.firstName && user.lastName ? `${user.firstName} ${user.lastName}` : user.userName}
                    </div>
                    <Icon icon="carrot-down"
                          className="user-menu__open" />
                </div>
                <ActionMenu>
                    <UserDetails
                        className="user-menu__details"
                        emailAsLink={false}
                        infoClassName="details-modal__info"
                        user={user}
                    />

                    <A to="/logout">
                        <Icon icon="logout" />
                        Log Out
                    </A>
                </ActionMenu>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/UserMenu/index.js